import { useState } from "react";
import { useQueryClient } from "react-query";

import api from "api";
import { querykeys } from "api/querykeys";
import * as models from "models";

export const useCheckTransitionsProvider = (timeInterval = 4000, reloadQty = 15) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const queryClient = useQueryClient();

  let qtyIntervalReload = 0;

  const intervalReload = (
    transactionId?: string,
    apiCall: (transactionId: string) => Promise<models.CheckTransactions | models.TokensResponse> = api.payment
      .checkTransactions,
  ) => {
    return new Promise((res, rej) => {
      transactionId && setIsLoading(true);

      const interval =
        transactionId &&
        setInterval(async () => {
          try {
            const response = await apiCall(transactionId);
            checkResponse(response as models.CheckTransactions & models.TokensResponse);
          } catch {
            checkResponse();
          }
        }, timeInterval);

      function checkResponse(response?: models.CheckTransactions & models.TokensResponse) {
        qtyIntervalReload++;
        if (qtyIntervalReload >= reloadQty) {
          interval && clearInterval(interval);
          setIsLoading(false);
          setIsError(true);
          rej({ status: "failed" });
        }
        if ((response?.is_processed && response?.success) || (response?.access && response?.refresh)) {
          interval && clearInterval(interval);
          queryClient.invalidateQueries(querykeys.loggedUser);
          setIsLoading(false);
          setIsError(false);
          res(response);
        }
      }
    });
  };

  return { isLoading, isError, intervalReload };
};
